/**
 * Turning {@link GraticuleOptions} into the state both graticule variants build
 * from. Defaults live here once, so the Canvas and WebGL layers cannot drift.
 */
import { createDefaultCellLabelHandler, resolveEdgeLabelHandler, } from './style.js';
import { LabelEngine } from './labels/LabelEngine.js';
/** Split graticule config from layer options and apply every default. */
export function resolveGraticuleOptions(options) {
    const { gridSystem, style, grids, xLabelPosition, yLabelPosition, xLabelOffset, yLabelOffset, edgeLabelCoverage, edgeLabelLeader, edgeLabelExtend, maxLines, blend, ...layerOptions } = options;
    const specs = grids ?? [
        { gridSystem: gridSystem ?? null, style },
    ];
    return {
        specs,
        edgeConfig: {
            xLabelPosition: xLabelPosition ?? 'top',
            yLabelPosition: yLabelPosition ?? 'left',
            xLabelOffset: xLabelOffset ?? 2,
            yLabelOffset: yLabelOffset ?? 2,
            edgeLabelCoverage: edgeLabelCoverage ?? 'all',
            edgeLabelLeader: edgeLabelLeader ?? 'none',
            edgeLabelExtend: edgeLabelExtend ?? 'line',
        },
        maxLines: maxLines ?? 100,
        blend,
        lensLineStyle: specs[0]?.style?.line ?? style?.line,
        layerOptions: layerOptions,
    };
}
/** The grid's label engine, or `null` when it draws neither label kind. */
export function createLabelEngine(spec, edgeConfig, maxLines, source) {
    const edgeLabelHandler = resolveEdgeLabelHandler(spec.style?.edgeLabel);
    const cell = spec.style?.cellLabel;
    const cellLabelHandler = cell === false ? null : (cell ?? createDefaultCellLabelHandler());
    if (!edgeLabelHandler && !cellLabelHandler)
        return null;
    return new LabelEngine({
        edgeLabelHandler,
        cellLabelHandler,
        edgeConfig,
        lineStyle: spec.style?.line,
        maxLines,
        source,
    });
}
//# sourceMappingURL=resolveOptions.js.map